import React from 'react';
import { SelectInput } from './SelectInput';

interface LimitRecordsSelectProps {
  value: number;
  onChange: (value: number) => void;
  customTestId?: string;
}

export const LimitRecordsSelect: React.FC<LimitRecordsSelectProps> = ({
  value,
  onChange,
  customTestId,
}) => {
  return (
    <SelectInput
      label="Limit records:"
      value={value}
      onChange={(e) => onChange(parseInt(e.target.value))}
      valuesAndOptions={[
        { value: 10, option: '10' },
        { value: 20, option: '20' },
        { value: 30, option: '30' },
        { value: 50, option: '50' },
        { value: 100, option: '100' },
        { value: 200, option: '200' },
        { value: 500, option: '500' },
        { value: 1000, option: '1000' },
      ]}
      width="w-1/8"
      custom_test_id={customTestId}
    />
  );
};
